import { PaywallResource } from "@v2/shared/lib/paywall/paywall.types";
import { Trello } from "types/my-trello-types";

export class PaywallResourceMapper {
  static toPaywallResources(
    trelloContext: Trello.PowerUp.Context
  ): PaywallResource[] {
    return Object.entries(trelloContext).map(
      ([key, value]: [keyof Trello.PowerUp.Context, string]) => {
        const _key = (() => {
          switch (key) {
            case "organization":
              return "workspace";
            default:
              return key;
          }
        })();

        return { type: _key, id: value };
      }
    );
  }

  static toTrelloContext(resources: PaywallResource[]): Trello.PowerUp.Context {
    const contextAsArray = resources.map(({ type, id }) => {
      const _type = (() => {
        switch (type) {
          case "workspace":
            return "organization";
          default:
            return type;
        }
      })() as keyof Trello.PowerUp.Context;

      return [[_type], id];
    });

    return Object.fromEntries(contextAsArray);
  }
}
